module.exports = __webpack_public_path__ + "img/b_rentrit.27e25b40.jpeg";